<app-admin-form [title]="'Vrooam CAB Informatie'" [object]="groupInfos??{}">

  <app-admin-input [label]="'CAB Groep(en)'" [focusInput]="focusInput" [(model)]="groups"
    (keyup.enter)="getGroupInfo(groups)" [selectOnclick]="true" [dividerKind]="groupInfos?0:1">
    <button class="btn btn-outline-secondary" type="button" (click)="getGroupInfo(groups)"
      [attr.disabled]="!groups?true:null">
      @if (busy) {
      <span><i class="fas fa-sync fa-spin"></i></span>
      } @else {
      <span><i class="far fa-search"></i></span>
      }
    </button>
  </app-admin-input>
  @if (groupInfos) {
  <app-admin-custom-control [label]="'Informatie'" [busy]="busyArticleSourceSearch" [dividerKind]="articleSourceSearchResponse?0:1">
    <div class="table-responsive">
      <table class="table table-hover table-striped table-bordered table-sm small text-nowrap">
        <thead>
          <tr class="table-dark">
            <td>Culture</td>
            <td>Groep type</td>
            <td class="text-end">Groepnummer</td>
            <td>Omchrijving</td>
            <td>Merk</td>
            <td>Leverancier</td>
            <td>Leveranciernaam</td>
            <td>Artikelgroep leverancier</td>
            <td class="text-end">Aantal artikelen</td>
          </tr>
        </thead>
        <tbody>
          @for (group of groupInfos; track group) {
          <tr class="pointer" (click)="articleSourceSearch(group)">
            <td>{{group.Culture}}</td>
            <td>{{group.VrmGroupType}}</td>
            <td class="text-end">{{group.VrmGroupNumber}}</td>
            <td>{{group.VrmGroupDescription}}</td>
            <td>{{group.VrmGroupBrand}}</td>
            <td>{{group.SupplierCode}}</td>
            <td>{{group.SupplierName}}</td>
            <td>{{group.SupplierGroup}}</td>
            <td class="text-end">
              {{group.ItemCount}}
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </app-admin-custom-control>
  }

  @if (articleSourceSearchResponse) {
  <app-admin-custom-control [label]="'Artikelen'" [busy]="busyArticleSourceSearch" [dividerKind]="-1">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <small class="text-muted">{{articleSourceSearchResponse.length}} resultaten</small>
      <div class="input-group input-group-sm w-auto">
        <label class="input-group-text" for="pageSizeSelect">Toon</label>
        <select id="pageSizeSelect" class="form-select" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()">
          @for (size of visiblePageSizeOptions; track size) {
          <option [ngValue]="size">{{size === 'all' ? 'Alles' : size}}</option>
          }
        </select>
      </div>
    </div>
    <!-- <app-article-source-response [response]="articleSourceSearchResponse"></app-article-source-response> -->
    <div class="table-responsive">
      <table class="table table-hover table-striped table-bordered table-sm small text-nowrap">
        <thead>
          <tr class="table-dark">
            <td>Wijzigingen</td>
            @for (key of keys; track key) {
            <td>{{key}}</td>
            }
          </tr>
        </thead>
        <tbody>
          @for (art of pagedArticleSourceSearchResponse; track art; let i = $index) {
          <tr class="pointer" (click)="openArticleSourceResponse(art)">
            <td class="text-center"><button *ngIf="art.History?.length" type="button" class="btn btn-light btn-xs"
                (click)="$event.stopPropagation(); articleSourceCompare(art)"><i class="fas fa-history"></i></button></td>
            @for (key of keys; track key) {
            @if (isDateKey(key)) {
            <td>{{art[key] | date : 'dd-MM-yyyy HH:mm'}}</td>
            } @else {
            <td>{{art[key]}}</td>
            }
            }
          </tr>
          }
        </tbody>
      </table>
    </div>

    @if (totalPages > 1) {
    <nav class="mt-2">
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" [class.disabled]="pageNumber === 1">
          <button type="button" class="page-link" (click)="changePage(pageNumber - 1)">&laquo;</button>
        </li>
        @for (page of pageNumbers; track page) {
        <li class="page-item" [class.active]="pageNumber === page">
          <button type="button" class="page-link" (click)="changePage(page)">{{page}}</button>
        </li>
        }
        <li class="page-item" [class.disabled]="pageNumber === totalPages">
          <button type="button" class="page-link" (click)="changePage(pageNumber + 1)">&raquo;</button>
        </li>
      </ul>
    </nav>
    }
  </app-admin-custom-control>
  }

</app-admin-form>